import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import axios from 'axios';
import config from "../config.json";
import { managementTeam } from "../Data/siteData";

type Employee = {
  id?: string | number;
  name?: string;
  first_name?: string;
  last_name?: string;
  title?: string;
  designation?: string;
  position?: string;
  photo?: string;
  photo_url?: string;
  image?: string;
  testimonials?: string;
  testimonial?: string;
  letter?: string;
  bio?: string;
  email?: string;
};

const TestimonialPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const dataId = searchParams.get('from') || 'No Data Passed';
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const [member, setMember] = useState<Employee | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const response = await axios.get(config.prodURL + "getemployees");
      const payload = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
      const allEmployees = Array.isArray(payload) ? payload : payload?.results || payload?.data || [];
      const foundMember = allEmployees.find((emp: Employee) => emp.id?.toString() === dataId);
      setMember(foundMember || null);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  if (!member) {
    return <div>Loading...</div>;
  }

  const fullName =
    `${member.first_name || ''} ${member.last_name || ''}`.trim() ||
    member.name ||
    "Team Member";
  const title = member.title || member.designation || member.position || "Leadership Team";
  const message = member.letter || member.testimonials || member.testimonial || member.bio || "No testimonial available.";
  const photo = member.photo_url || member.photo || member.image;
  const fallbackProfile = managementTeam.find((profile) => {
    const profileName = profile.name?.trim().toLowerCase();
    return profileName === fullName.trim().toLowerCase() || profile.id?.toString() === member.id?.toString();
  });
  const email = member.email?.trim() || fallbackProfile?.email || "info@brahmajyotiholdings.com";

  return (
    <div className="testimonial-detail-page">
      <div className="testimonial-detail-shell">
        <button type="button" className="testimonial-back-button" onClick={goBack}>
          <ArrowLeftOutlined />
          <span>Go back</span>
        </button>

        <div className="testimonial-detail-card">
          {photo && (
            <div className="testimonial-detail-photo-frame">
              <img src={photo} alt={fullName} className="testimonial-detail-photo" />
            </div>
          )}

          <div className="testimonial-letter">
            <div className="testimonial-letter-body">
              {message}
            </div>

            <div className="testimonial-letter-signoff">
              <p className="testimonial-signature-name">{fullName}</p>
              <p className="testimonial-signature-title">{title}</p>
              <a href={`mailto:${email}`} className="testimonial-signature-email">
                {email}
              </a>
              <p className="testimonial-signature-company">Brahma Jyoti Holdings Limited</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialPage;
